import { mapApprovalScope } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/approvalScope.utils';
import { channelApi, subCompanyAgencyApprovalsApi, subCompanyChannelsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing reads — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_APPROVAL_SCOPE_ACTION_TYPE = createNamedActions(
  'commandCenterApprovalScope',
  {
    SET_APPROVAL_SCOPE: 'SET_APPROVAL_SCOPE',
  },
);

export const getCommandCenterApprovalScopeAction = catchAsyncActionError(
  ({ subCompanyId }) =>
    async dispatch => {
      const [{ data: agencyApprovals }, { data: subCompanyChannels }, { data: channelCatalog }] =
        await Promise.all([
          subCompanyAgencyApprovalsApi.getSubCompanyAgencyApprovals({
            subCompanyId,
            config: SKIP_FORBIDDEN_CONFIG,
          }),
          subCompanyChannelsApi.getSubCompanyChannels({
            subCompanyId,
            config: SKIP_FORBIDDEN_CONFIG,
          }),
          channelApi.getChannels(),
        ]);

      return dispatch({
        type: COMMAND_CENTER_APPROVAL_SCOPE_ACTION_TYPE.SET_APPROVAL_SCOPE,
        payload: mapApprovalScope({
          agencyApprovals: agencyApprovals ?? null,
          subCompanyChannels: subCompanyChannels ?? [],
          channelCatalog: channelCatalog ?? [],
        }),
      });
    },
);
